/* tslint:disable */

/**
 */
export class BarcodeForm {
    code?: string;
    deviceID?: string;
    time?: string;
}
